import React from "react";
import { Carousel } from "react-bootstrap";
import Reportppm from "./summary/reportsmkhp2";
import ReportHaccp from "./summary/reporthaccp";
import ReportUmku from "./summary/reportprimer2";
// import Reportall from "./summary/allreport";
//import ReportPasca from "./summary/ReportPasca";

const Header = () => {
  // List carousel
  const reports = [
    { id: 2, component: <ReportHaccp /> },
    { id: 3, component: <ReportUmku /> },
    { id: 1, component: <Reportppm /> },
   // { id: 4, component: <ReportPasca /> },
   // { id: 4, component: <Reportall /> },
  ];

return (
    <header id="header" className="mt-5">
  <Carousel 
    controls 
    indicators 
    slide 
    interval={5000} 
    className="main-carousel"
    touch={true} 
  >
    {reports?.map((report) => (
      <Carousel.Item key={report.id}>
        <div className="carousel-image-wrapper container-fluid">
          {report.component}
        </div>
      </Carousel.Item>
    ))}
  </Carousel>
</header>
  );
};

export default Header;